import { render, staticRenderFns } from "./modalGifting.vue?vue&type=template&id=64690e37&"
import script from "./modalGifting.vue?vue&type=script&lang=js&"
export * from "./modalGifting.vue?vue&type=script&lang=js&"
import style0 from "./modalGifting.vue?vue&type=style&index=0&id=64690e37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports